export default __webpack_public_path__ + "static/gta_roofing_2-cb2094d55e26d151f3aea49547d513fe.jpg";